import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M2.23011 11.0514C4.54011 4.11138 10.9101 4.74138 10.9101 4.74138C10.9101 4.74138 11.8801 2.11138 14.8701 1.29138C17.3601 0.60138 21.7301 0.841381 24.4301 5.33138C29.3301 13.5014 23.6101 28.7514 10.9601 26.9714C4.42009 26.0414 -0.399892 18.9214 2.23011 11.0514Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.93018 5.18134C8.93018 5.18134 18.8402 4.65134 22.2402 17.9913"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M15.1501 1.46143C15.1501 1.46143 23.7402 2.61142 23.2002 16.5014"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M4.68018 7.92139C4.68018 7.92139 7.5402 16.3614 21.7002 18.2714"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M1.65015 15.8313C1.65015 15.8313 7.41015 23.8513 20.7502 21.6713"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M95.72 11.0514C93.41 4.11138 87.04 4.74138 87.04 4.74138C87.04 4.74138 86.07 2.11138 83.08 1.29138C80.59 0.60138 76.22 0.841381 73.52 5.33138C68.62 13.5014 74.34 28.7514 86.99 26.9714C93.53 26.0414 98.35 18.9214 95.72 11.0514Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M88.75 5.29128C88.75 5.29128 79.11 4.65128 75.71 17.9913"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M82.8 1.46143C82.8 1.46143 74.21 2.61142 74.75 16.5014"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M93.27 7.92139C93.27 7.92139 90.41 16.3614 76.25 18.2714"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M96.2999 15.8313C96.2999 15.8313 90.54 23.8513 77.2 21.6713"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M73.7499 13.3215C68.3399 6.56152 56.1299 2.56152 49.0299 2.56152C41.9299 2.56152 29.6099 6.56152 24.1999 13.3215C14.5099 25.4315 21.1199 52.0715 21.1199 52.0715C21.1199 52.0715 21.7799 30.4915 29.0499 24.1115C35.2399 18.6715 40.9199 20.7615 48.9799 20.7615C57.0399 20.7615 62.7199 18.6815 68.9099 24.1115C76.1799 30.5015 76.8399 52.0715 76.8399 52.0715C76.8399 52.0715 83.4399 25.4315 73.7499 13.3215Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M31.3401 7.43164C31.3401 7.43164 39.9301 8.75164 43.4001 20.8116"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M26.3801 11.8916C26.3801 11.8916 30.8401 11.8816 33.8201 21.3016"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M22.4199 15.6417C22.4199 15.6417 27.2599 14.9817 28.2099 24.4417"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M66.6201 7.43164C66.6201 7.43164 58.0301 8.75164 54.5601 20.8116"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M71.5801 11.8916C71.5801 11.8916 67.1201 11.8816 64.1401 21.3016"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M75.54 15.6417C75.54 15.6417 70.7 14.9817 69.75 24.4417"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M23.86 13.3215C23.86 13.3215 18.3 24.6015 23.25 36.3315"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M74.0901 13.3215C74.0901 13.3215 79.6501 24.6015 74.7001 36.3315"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M48.9743 18.7271C48.8519 18.0962 48.7607 17.4622 48.6865 16.8237C48.5388 15.554 48.4698 14.2834 48.4698 13.0115L48.4698 13.0076C48.46 11.7408 48.5385 10.4716 48.6865 9.19923C48.7607 8.56071 48.8492 7.92815 48.9698 7.29963C49.0904 7.92815 49.1789 8.56071 49.2532 9.19923C49.4008 10.4689 49.4698 11.7396 49.4698 13.0115C49.4698 14.2809 49.3911 15.5527 49.2527 16.8275L49.2527 16.8279C49.1838 17.4675 49.0957 18.1001 48.9743 18.7271Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
